import modules_rules from './rules/index.js'
import modules_form from './form/index.js'
import _actions_change_tab from './_actions/change/tab.js'
import _actions_create from './_actions/create.js'
import _actions_clean from './_actions/clean.js'
import _mutations_set from './_mutations/set.js'
import _mutations_loading from './_mutations/loading.js'
import _mutations_clean from './_mutations/clean.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        clean: _mutations_clean,
        loading: _mutations_loading,
        set: _mutations_set,
    },
    actions:{
        clean: _actions_clean,
        create: _actions_create,
        change_tab: _actions_change_tab,
    },
    modules:{
        form: modules_form,
        rules: modules_rules,
    },
}